import { Typography } from '@material-ui/core';
import { Button, ButtonProps } from '@superdispatch/ui-lab';
import { formatCurrency } from 'shared/helpers/IntlHelpers';
import { InstantIcon } from 'shared/icons/InstantIcon';
import styled, { css } from 'styled-components';
import { PostingLoadDTO } from '../../data/dto/PostingLoadDTO';

const Styled1 = styled(Typography)`
  line-height: inherit;
`;

function PriceValueFormatted({ price }: { price: number | null }) {
  return (
    <Styled1 display="inline" variant="h3">
      {formatCurrency(price || 0, { minimumFractionDigits: 0 })}
    </Styled1>
  );
}

const StyledButton = styled(Button)(
  ({ theme }) => css`
    padding-right: ${theme.spacing(2)}px;
    padding-left: ${theme.spacing(2)}px;
  `,
);

export function RequestPostingButton({
  title,
  price,
  ...buttonProps
}: { title: string; price: number } & Omit<ButtonProps, 'color' | 'variant'>) {
  return (
    <StyledButton
      variant="success"
      size="large"
      aria-label={title}
      {...buttonProps}
    >
      <Typography variant="body1" noWrap={true}>
        {title}
      </Typography>{' '}
      &nbsp;&nbsp;
      <PriceValueFormatted price={price} />
    </StyledButton>
  );
}

export function BookPostingButton({
  price,
  ...buttonProps
}: { price: PostingLoadDTO['price'] } & Omit<
  ButtonProps,
  'color' | 'variant'
>) {
  return (
    <StyledButton
      variant="primary"
      size="large"
      startIcon={<InstantIcon />}
      aria-label="Book now"
      {...buttonProps}
    >
      <Typography variant="body1" noWrap={true}>
        Book Now
      </Typography>{' '}
      &nbsp;&nbsp;
      <PriceValueFormatted price={price} />
    </StyledButton>
  );
}
